module.exports = __webpack_public_path__ + "media/landing_page/lp4-hero-mobile-01-d8e94e5b.webp";